// extracted by extract-css-chunks-webpack-plugin
module.exports = {"boardsList":"BoardsList__boardsList___1ym4W","boardsListBody":"BoardsList__boardsListBody___19aib","title":"BoardsList__title___2vPjC"};
    if(module.hot) {
      // 1778083487281
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  